module.exports = __webpack_public_path__ + "static/media/hard-hat.2d4d2124.svg";